import { gate } from 'hub-http/gates';
export const ABUSE_DESK_CHIRP_GATE = gate('AbuseMitigation::ContentLabelLib::AbuseDeskChirp');